<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hserv">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>SERVICIOS</h1>
                    <p>Para cuidar de su salud hemos dispuesto consultorios médicos y dentales cercanos a su domicilio, lugar de trabajo, donde le brindamos atención con calidad y calidez.</p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>
<div class="contenedorIntSub">
    <div class="FcfrCst">
        <div class="FcfrCstInt dSieteM dtDiez dmDoce flx">
            <div class="dDiez dmOnce FcttAzul flx">
                <div class="dDoce">
                    <h3 class="FcifrasDatos text-white pt-2">HAZ CLIC Y UBICA TU UNIDAD MÁS CERCANA </h3>
                </div>
                <div class="dCuatro dmCuatro FcfrBllt">
                <a (click)="goConsultorios()">
                    <img src="./assets/images/icon-consultorios.svg" alt="Consultorios médicos">
                    <p class="FcifrasDatos">
                        CONSULTORIOS<br/>MÉDICOS
                    </p>
                </a>
                </div>
                <div class="dCuatro dmCuatro FcfrBllt">
                <a (click)="goConsultoriosDentales()">
                    <img src="./assets/images/icon-dentales.svg" alt="Consultorios dentales">
                    <p class="FcifrasDatos">
                        CONSULTORIOS<br/>DENTALES
                    </p>
                </a>
                </div>
                <div class="dCuatro dmCuatro FcfrBllt">
                    <a (click)="goConsultoriosNutricionales()">
                        <img src="./assets/images/icon-nutricion.svg" alt="Consultorios nutricionales">
                        <p class="FcifrasDatos">
                            CONSULTORIOS<br/>NUTRICIONALES
                        </p>
                    </a>
                </div>
                <div class="dCuatro dmCuatro FcfrBllt">
                    <a (click)="goConsultoriosPsicologicos()">
                        <img src="./assets/images/icon-psicologico.svg" alt="Consultorios Psicologicos">
                        <p class="FcifrasDatos">
                            CONSULTORIOS<br/>PSICOLÓGICOS
                        </p>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="espacioDefault"></div>
	
    <div class="srvAv dNueveM dtDiez dmNueveM flx text-white text-center">
        <h2 class="dDoce text-left">OTRAS ACTIVIDADES</h2>
        <div class="dCuatro dmDoce sAv1">
            <img src="./assets/images/servicios-simicarreras.jpg" alt="Simicarreras" />
            <div class="sA1 flx alc">
                <h3 class="dDoce text-white pt-xl-2 pt-lg-2 pt-md-2 pt-sm-1 pt-1">SIMICARRERAS</h3>
                <p class="text-justify">
					En este tipo de eventos, se ofrece de forma gratuita tanto a participantes (corredores) y público asistente, toma de presión arterial, medición de glucosa, peso y talla, asesoría médica y atención de urgencias.
				</p>
            </div>
        </div>
        <div class="dCuatro dmDoce sAv2">
            <div class="sAv2Int flx">
                <div class="sASd flx alc">
					<div class="dDoce">
						<h3 class="text-white mt-1 pt-2">FERIAS DE LA SALUD</h3>
						<p>
							Para este tipo de actividades, acuden brigadas médicas, básicamente para extender certificados médicos escolares y/o laborales, previa solicitud de escuelas, empresas, instituciones y/o dependencias de gobierno tanto local como a nivel federal. Actualmente, contamos con reconocimiento y presencia a todo lo largo y ancho del país.
						</p>
					</div>
                </div>
                <div class="sAEsc flx alc">
					<div class="dDoce">
						<h3 class="text-white mt-1 pt-2">FERIAS ESCOLARES</h3>
						<p>
							Como apoyo a las escuelas primarias y secundarias, los médicos imparten charlas a los estudiantes y profesores, a través de un lenguaje sencillo y divertidas dinámicas, en las que enseñan y resuelven dudas en temas como: alimentación, higiene, prevención de accidentes, riesgos de la automedicación, saneamiento ambiental, seguridad escolar, etc.
						</p>
					</div>
                </div>
            </div>
        </div>
        <div class="dCuatro dmDoce sAv3">
            <img src="./assets/images/servicios-apoyo.jpg" alt="Apoyo a contingencias naturales" />
            <div class="sA3 flx alc">
				<div class="dDoce">
					<h3 class="dDoce text-white pt-1">APOYO A CONTINGENCIAS NATURALES</h3>
					<p class="text-justify">
						Ante la presencia de desastres naturales que afectan año tras año al territorio nacional, Fundacion Best, se ha hecho presente directamente en el lugar afectado, a través de sus médicos, los cuales brindan atención en salud, adaptándose a las condiciones del lugar y el momento, todo esto y mas, con la única intención de ayudar al necesitado.
					</p>
				</div>
            </div>
        </div>
        <div class="dDoce sAv4 flx alc text-justify">
			<div class="dDoce">
				<h3 class="text-white pt-2">JUNTAS Y CAPACITACIONES MÉDICAS</h3>
				<p>
					Fundación Best fomenta la capacitación médica continua tanto en forma presencial, como a distancia con expertos en las diferentes materias de interés y mediante la revista ConCiencia Médica. También, sesiona con los directivos y cuerpo de supervisores médicos para conocer y fortalecer la mística, visión y valores que nos distinguen de los demás. Todo con el único fin de ofrecer cada día mejores servicios médicos.
				</p>
			</div>
        </div>
    </div>
</div>
</div>
